import { route } from "quasar/wrappers";
import {
  createRouter,
  createMemoryHistory,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
import routes from "./routes";
import ShowToastMixin from "../mixins/notify"

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default route(function (/* { store, ssrContext } */) {
  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === "history"
    ? createWebHistory
    : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,
    

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(
      process.env.MODE === "ssr" ? void 0 : process.env.VUE_ROUTER_BASE
    ),
  });

  Router.beforeEach((to, from, next) => {
    var tokenStr = JSON.parse(localStorage.getItem("user"));

    if (
      to.path === "/login" ||
      to.path === "/reset" ||
      to.path === "/password" ||
      to.path === "/downloads" ||
      to.path.includes("/catalogo") ||
      to.path.includes("/carrinho") ||
      to.path.includes("/conta") ||
      to.path.includes("/pedido")
    ) {
      next();
    } else if (
      !tokenStr ||
      !tokenStr.usuario ||
      Date.now() > tokenStr.expires_on
    ) {
      ShowToastMixin.showToast("Sua sessão expirou. Faça login novamente")
      next("/login");
    } else {
      next();
    }
  });

  return Router;
});
